module.exports = __webpack_public_path__ + "static/media/web3.02cd6fe7.jpeg";